import { QueryFunctionContext } from "@tanstack/react-query";

const URL =
  (globalThis.constructor.name === "Window" && location.hostname === "localhost"
    ? "http://localhost:8080"
    : "") + "/api/cidadao/";

export interface PostCidadaoProps {
  id_gov: string;
  nome: string;
  email: string;
}

export default async function postCidadao({ queryKey }: QueryFunctionContext) {
  const body = JSON.stringify(queryKey[1] as PostCidadaoProps);
  try {
    await fetch(URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    });
  } catch (error) {
    console.error("Error fetching citizen:", error);
  }
  return true;
}
